var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"variant":"light","options":_vm.options,"value":_vm.$route.query['filter[status]'] ? _vm.$route.query['filter[status]'] : null},on:{"change":function($event){return _vm.$emit('statusFiltered', {status: $event})}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35a27e5c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserPanel/Elements/StatusSelect.vue
// module id = null
// module chunks = 